import { lt, useGainsightService } from '@mews/framework';
import { Identifiable } from '@mews/std';
import { EmptyState, LinkButton } from '@optimus-web/core';
import { MatchAndMergeGainSightEvents } from '../../../../GainSightEvents';
import { useOpenGuestProfile } from '../common/hooks';

export const GuestDetailEmptyContent = ({ id }: Identifiable) => {
    const gainSightService = useGainsightService();
    const openGuestModal = useOpenGuestProfile({ id });

    const openGuestProfile = () => {
        gainSightService.trackEvent(MatchAndMergeGainSightEvents.MatchAndMergeNavigatedToCustomerProfile, {
            customerId: id,
        });
        openGuestModal();
    };

    return (
        <EmptyState
            primaryText={lt('AccountMergeGuestDetailEmptyPrimaryLabel')}
            secondaryText={lt('AccountMergeGuestDetailEmptySecondaryLabel')}
            pictogram="folder"
            action={
                <LinkButton variant="secondary" size="small" onClick={openGuestProfile}>
                    {lt('AccountMergeGuestDetailEmptyActionLabel')}
                </LinkButton>
            }
        />
    );
};
